var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivison(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1381 2.45774C13.073 2.91086 6.68273 5.63083 5.61889 6.08395C5.17179 6.27366 4.89917 6.69417 4.89917 7.17871C4.89917 12.4712 5.1112 14.8395 6.07326 17.5667C7.33218 21.1373 9.80398 23.983 13.9866 26.367C14.3586 26.5797 14.8263 26.5797 15.1983 26.367C19.4185 23.9612 21.9012 21.1253 23.1492 17.5667C24.0992 14.8589 24.2858 12.6065 24.2858 7.17871C24.2858 6.69658 24.0107 6.27487 23.566 6.08395L15.1232 2.45774C14.8178 2.32724 14.4434 2.32724 14.1381 2.45774ZM14.5925 4.83694L21.8576 7.98226C21.963 16.652 20.2594 20.4522 14.6034 23.9093C8.80072 20.3097 7.2595 16.4684 7.31887 7.99192C8.97037 7.28867 13.1954 5.43144 14.5925 4.83694Z",
    fill: "#2A343D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivison);
export default __webpack_public_path__ + "static/media/Divison.d9dce41ce8749943d995557456da1524.svg";
export { ForwardRef as ReactComponent };